import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { XmasTreeDecorated, XmasTree } from '@client/components/shared/SvgIcons';
import { WrapperSection, articleDetail, mylounge} from './styles';
import { SpecialBannerProps, XMAS_BANNER_LOCATION } from './types';
import Translate from '@client/components/shared/translation/Translate';

const renderSpecialBannerByLocation = (location: XMAS_BANNER_LOCATION):ReactNode => {
    switch (location) {
        case XMAS_BANNER_LOCATION.catalog:
            return (
                <WrapperSection>
                    <XmasTreeDecorated className="icon" />
                    <Translate message="xmasSpecial" />
                </WrapperSection>
            )
        case XMAS_BANNER_LOCATION.articleDetail:
            return (
                <ThemeProvider theme={articleDetail}>
                    <WrapperSection>
                        <XmasTreeDecorated className="icon" />
                        <Translate message="xmasSpecial" />
                    </WrapperSection>
                </ThemeProvider>
            )
        case XMAS_BANNER_LOCATION.mylounge:
            return (
                <ThemeProvider theme={mylounge}>
                    <WrapperSection>
                        <XmasTree className="icon--small" />
                        <Translate message="xmasSpecial" />
                    </WrapperSection>
                </ThemeProvider>
            )
    }

};

export const SpecialBanner: React.FunctionComponent<SpecialBannerProps> = ({ location }) => {
    const isArticleDetail = location === 'articleDetail';
    const isCatalog = location === 'catalog';
    const isMylounge = location === 'mylounge';

    return (
    <React.Fragment>
        {isCatalog && renderSpecialBannerByLocation(XMAS_BANNER_LOCATION.catalog)}
        {isArticleDetail && renderSpecialBannerByLocation(XMAS_BANNER_LOCATION.articleDetail)}
        {isMylounge && renderSpecialBannerByLocation(XMAS_BANNER_LOCATION.mylounge)}
    </React.Fragment>
)};


export default SpecialBanner;
